import React from "react";
import SEO from "../components/SEO";

const OurCommittee = () => {
  // Committee members data
  const nationalCommittee = [
    {
      id: 1,
      name: "A. CHARLES",
      position: "National President",
      image: "/images/members/charles.jpg",
      description: "Chief Editor – Police News Plus. Leading the NAI with a vision for the future of journalism.",
      contact: "president@naiindia.in",
    },
    {
      id: 2,
      name: "PCR SURESH",
      position: "National Chairman Advisory Board",
      image: "/images/members/pcr-suresh.jpg",
      description: "Consultant Editor – Police News Plus E-News Daily. CEO – Eastern Shepherd International.",
      contact: "advisory@naiindia.in",
    },
    {
      id: 3,
      name: "R.C. PAUL KANAGARAJ",
      position: "Honorary Member",
      image: "/images/members/paul-kanagaraj.jpg",
      description: "President – Madras High Court Advocates Association.",
      contact: "contact@naiindia.in",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="National Committee | Newsmedia Association of India"
        description="Meet the National Executive Committee and leadership of Newsmedia Association of India (NAI). Dedicated professionals steering the future of journalism."
        keywords="NAI Committee, NAI Leadership, A Charles NAI, PCR Suresh NAI, Media Leadership India"
      />
      {/* Hero Section */}
      <section 
        className="relative bg-blue-900 text-white py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/committee.jpg')" }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              NAI National Committee
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto">
              Meet the dedicated leaders steering the Newsmedia Association of
              India towards excellence
            </p>
          </div>
        </div>
      </section>

      {/* National Committee Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              National Executive Committee
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our national leadership team brings together experienced media
              professionals committed to advancing journalism in India
            </p>
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
            {nationalCommittee.map((member) => (
              <div
                key={member.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group w-full max-w-sm"
              >
                {/* Member Image */}
                <div className="h-80 bg-gray-200 relative overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {/* Position Badge */}
                  <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-md">
                    {member.position}
                  </div>
                </div>

                {/* Member Details */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                    {member.name}
                  </h3>
                  <p className="text-blue-600 font-semibold text-sm mb-3">
                    {member.position}
                  </p>
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {member.description}
                  </p>

                  {/* Contact Info */}
                  <div className="border-t border-gray-100 pt-4">
                    <div className="flex items-center text-sm text-gray-500">
                      <svg
                        className="w-4 h-4 mr-2 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                      <span className="truncate">{member.contact}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Organizational Structure */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Organizational Structure
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Understanding our hierarchical framework for effective governance
            </p>
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
              <div className="p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">President</h3>
                <p className="text-sm text-gray-600">
                  Overall leadership and strategic direction
                </p>
              </div>

              <div className="p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">
                  Advisory Board
                </h3>
                <p className="text-sm text-gray-600">
                  Providing guidance and expert counsel
                </p>
              </div>

              <div className="p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">
                  Secretarial Team
                </h3>
                <p className="text-sm text-gray-600">
                  Administrative and operational management
                </p>
              </div>

              <div className="p-6 rounded-xl hover:bg-gray-50 transition-colors duration-300">
                <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                    />
                  </svg>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">
                  Executive Members
                </h3>
                <p className="text-sm text-gray-600">
                  Specialized committees and regional representation
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">
            Connect With Our Committee
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-blue-100">
            Interested in collaborating or learning more about our leadership
            team? Reach out to us.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Contact Committee
            </button>
            <button className="border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300">
              Download Directory
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurCommittee;
